/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable quote-props */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/semi */

import { User } from '../user'

/*
{
  "firstName": "John",
  "lastName": "Doe",
  "emailNotificationsEnabled": true
}
*/
export class UserDTO {
  firstName: string = ''
  lastName: string = ''
  emailNotificationsEnabled: boolean = false


  public setDTOFromModel(user: User) {
    //Base.log("[" + this._page + "] DTO")
    //console.log(user)
    this.firstName = user.firstname
    this.lastName = user.lastname
    this.emailNotificationsEnabled = user.emailNotificationsEnabled
  }

}
